// Мир игрока и сетка его местности — один раз за сессию: карта открывается без повторных запросов
// и пересчёта сетки (это заметные доли секунды на телефоне). Экран загрузки готовит их заранее.
import { get } from '@/api/client';
import { generateTerrainGrid, worldRows } from '@sk/shared';

export interface WorldGrid {
  grid: ReturnType<typeof generateTerrainGrid>;
  size: number;
  rows: number;
  seed: number;
  /** Клетки карты с учётом вырубки леса у построек (CELL.*): где отряд идёт внутри леса. */
  forestCells?: Uint8Array;
}

let pending: Promise<WorldGrid> | null = null;

export function worldGrid(): Promise<WorldGrid> {
  if (!pending)
    pending = get<{ seed: number; size: number }>('/world/current')
      .then((w) => ({
        grid: generateTerrainGrid(w.seed, w.size),
        size: w.size,
        rows: worldRows(w.size),
        seed: w.seed,
      }))
      .catch((e) => {
        pending = null;
        throw e;
      });
  return pending;
}

/** Сменился мир (переход в другой мир, выход) — пересчитать. */
export function forgetWorldGrid(): void {
  pending = null;
}
